import { map, share } from 'rxjs'
import { jsonMapper } from '../../data/json-mapper.js'
import { Class } from '../../types.js'
import { OperatorFunction } from 'rxjs'

type JsonMapping<T, M> = [(input: T) => M, (mapped: M, input: T) => T]
export function jsonMap<T, M extends object, M_or_Arr extends M | M[]>(
	ctor: Class<M>,
	mappings?: JsonMapping<T, M_or_Arr>[],
): OperatorFunction<T, T> {
	if (!mappings) mappings = [[(x: T) => x, (x: M_or_Arr) => x]] as any
	return (input$) => {
		return input$.pipe(
			map((input) => {
				let obj = input
				for (const mapping of mappings!) {
					const toBeMapped = mapping[0](obj)
					const mapped: typeof toBeMapped = jsonMapper.deserializeFromObject(
						toBeMapped,
						ctor,
					) as any

					obj = mapping[1](mapped as any, obj)
				}
				return obj
			}),
			share(),
		)
	}
}
